export default __webpack_public_path__ + "static/media/edutech.7ce070d5.png";